import axios from 'axios'
import store from '@/store'
import { getJwtObj } from './jwt'
import { showLoading, hideLoading } from './loading'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

service.interceptors.request.use(request => {
  // log('>>> request', request)

  // showLoading()
  // var token = uni.getStorageSync('authorization')
  var token = store.getters.token

  if (token) {
    request.headers['authorization'] = token
  }

  // 设置route
  const route = store.getters.route
  if (route) {
    request.headers['vue-route'] = route
  }

  return request
})

// response interceptor
service.interceptors.response.use(
  response => {
    hideLoading()
    let token = response.headers.authorization
    if (token && typeof token === 'object' && token.length > 0) {
      token = token[0]
    }
    // should not save token, when existing token has user ID, but new token is visitor
    // 解决的问题：api调用滞后，导致返回的visitor token覆盖了user token
    const skipSetting = checkTokenSettingShouldBeSkip(token)

    if (token && !skipSetting) {
      // log('saving authorization', token)
      // uni.setStorageSync('authorization', token)
      store.dispatch('root/set_token', token)
    }
    return response.data
  },
  err => {
    hideLoading()
    log('!!! err', err)
    store.dispatch('root/clear')
    // unauthorized
    if (err.response && err.response.status === 401) {
      // token 没内容时，不弹出错误信息（用户初次打开页面）
      if (!err.response.authorization) {
        return
      }

      return uni.showModal({
        title: '您的权限不够',
        showCancel: false
      })
    }

    let errMsg =
      (err.response && err.response.data && err.response.data.error) || JSON.stringify(err.response && err.response.data) || err.message || ''
    if (err.response && err.response.status === 502) {
      const url = err.request && err.request.url
      if (url) {
        errMsg = `${errMsg}\n${url}`
      }
    }

    {
      const statusCode = err.response && err.response.status
      const url = err.request && err.request.url
      if (statusCode === 502) {
        errMsg = '502 Bad Gateway'
      }

      if (statusCode > 401 && url) {
        errMsg = `${statusCode} ${url}`
      }
    }

    // 发生网络错误后会走到这里
    log('网络错误', err)
    uni.showModal({
      title: '提示',
      content: errMsg,
      showCancel: false
    })
  }
)

const checkTokenSettingShouldBeSkip = token => {
  const obj = getJwtObj(token)
  const isVisitor = obj.visitor
  if (isVisitor) {
    return true
  }

  return false
}
function log() {
  console.log.apply(null, arguments)
}

export default service
